<template>
    <fb-form-body>

        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" >

            <el-form-item label="标题" prop="title" :error="formErrorMsg.title" class="fb-form-item">
                <el-input v-model="formData.title"></el-input>
            </el-form-item>

            <el-form-item label="内容" prop="content" :error="formErrorMsg.content" class="editor-item" >

                <quill-editor v-model="formData.content" :options="editorOption" ref="myQuillEditor"></quill-editor>
            </el-form-item>

            <el-form-item label="状态" prop="status"  class="fb-form-item">
                <dict-select v-model="formData.status" type-flag="SYSTEM_NOTICE_STATUS" ></dict-select>
            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import ModuleCascader from "../../components/ModuleCascader";
    import DictSelect from "../../components/DictSelect";
    export default {
        name: "RoleAdd",
        components: {DictSelect, ModuleCascader},
        data() {
            return {
                editorOption: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'font': [] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link', 'image', 'video']
                        ],
                        syntax: {
                            highlight: text => hljs.highlightAuto(text).value
                        }
                    }
                },
                api:{
                   add:this.$api.systemNotice.add
                },
                formErrorMsg:{
                    name: '',
                    content: '',
                    status: '',
                },
                formData: {
                    name: '',
                    content: '',
                    status: '',
                },
                rules: {
                    title: [
                        {required: true, message: '请输入标题', trigger: 'blur'},
                    ],
                    content: [
                        {required: true, message: '请输入内容', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择公告状态', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }



</style>


<style>
    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>